import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { adminAddCommunityAccount, adminDeleteAccount, adminUpdateAccountData, searchUsers } from "../../../services/users";
import { adminInsertOne, deletePostById, fetchPosts } from "../../../services/posts";
import { uploadPhoto } from "../../../services/documents";
import PageSelector from "../../../components/PageSelector";
import FileDropzone from '../../../components/FileDropzone'
import {validateEmail} from '../../../utils/util'
const limit = 10

function Page(props) {
    const { id } = useParams(); 
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [isloading,setIsloading]=useState(false)
 

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem/limit)||1
    const [data,setData]=useState([])
    const page =  parseInt(searchParams.get('page'))||1
    const [accounts,setAccounts]=useState([])
    const [selectedAccount,setSelectedAccount]=useState(null)
    const handleSelectPage=(p)=>()=>{
        if(p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    async function fetchMerchantAccounts() {
        const filter = { type: 'user', status: 'active', partnerId: id }
        const res = await searchUsers(props.token.token, filter, { limit: 99 })
        if (res.result){
            setAccounts(res.result)
        }
    }
    const handleSelectAccount=(item)=>()=>{
        if(selectedAccount===item?._id){
            setSelectedAccount(null)
            return
        }
        setSelectedAccount(item?._id)
    }

    useEffect(()=>{
        fetchMerchantAccounts()
    },[page,id])

    async function fetchPostsData(){
        if(!selectedAccount) {
            setData([])
            setTotalItem(0)
            return
        }
        setIsloading(true)
        const res = await fetchPosts({userId:selectedAccount,status:'published'},{limit,skip:(page-1)*limit,sort:{_id:-1}})
        if(res.errno===0){
            setData(res.result)
            setTotalItem(res.count)
        }
        setIsloading(false)
    }
    useEffect(()=>{
        fetchPostsData()
    },[selectedAccount,page])

    const [isCreating,setIsCreating]=useState(false)
    const handleNewPost=()=>{
        if(!selectedAccount) return alert('請先選擇一個合作夥伴帳號')
        setIsCreating({})
    }
    const handleConfirmCreateNewPost=async()=>{
        if(!isCreating?.content || isCreating?.content.trim()==='') return alert('請輸入內容')
        setIsloading(true)
        let photosUrls = []
        if(isCreating?.photos?.length>0){
            for(const file of isCreating.photos){
                if(file instanceof File){
                    let url = await onUploadOneImgae(file,`${id}/${selectedAccount}`)
                    if(url) photosUrls.push(url)
                } else if (typeof file === 'string') {
                    photosUrls.push(file)
                }
            }
        }
        let res = await adminInsertOne(props.token?.token,selectedAccount,isCreating.content,photosUrls.length>0?photosUrls:null)
        if(res.errno===0){
            setIsCreating(false)
            fetchPostsData()
        } else {
            alert(res.message||'新增失敗')
        }
        setIsloading(false)
    }
    const onDropFile=(files)=>{
        if(!isCreating) return
        if(!files||files.length===0) return
        let newFiles = files||[]
        let currentFiles = isCreating?.photos||[]
        if(currentFiles.length+newFiles.length>9) return alert('最多只能上傳9張圖片')
        setIsCreating({...isCreating,photos:[...currentFiles,...newFiles]})
    }

    const onUploadOneImgae = async (file,folder) => {
        if (!['image/png', 'image/jpeg'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        let res = await uploadPhoto(props.token?.token, formData, folder, Date.now()) //partnerId/userId/timestamp
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                return res.result 
            }
        }
        return null
    }

    const [isDeleting,setIsDeleting]=useState(false)
    const handleConfirmDeletePost=async()=>{
        if(!isDeleting) return
        setIsloading(true)
        let result = await deletePostById(props.token?.token,isDeleting?._id)
        if(result.errno===0){
            setIsDeleting(false)
            fetchPostsData()
        } else {
            alert(result.message||'刪除失敗')
        }
        setIsloading(false)
    }

    const [isUpdatingAccountData,setIsUpdatingAccountData]=useState(false)
    const handleConfirmUpdateAccountData=async()=>{
        if(!isUpdatingAccountData) return
        if(!isUpdatingAccountData?.data?.englishName || isUpdatingAccountData?.data?.englishName.trim()==='') return alert('請輸入顯示名稱')
        setIsloading(true)
        let uploadJson={
            englishName:isUpdatingAccountData?.data?.englishName,
            position:isUpdatingAccountData?.data?.position,
            company:isUpdatingAccountData?.data?.company,
        }
        if(isUpdatingAccountData?.data?.avator && isUpdatingAccountData?.data?.avator instanceof File){
            let url = await onUploadOneImgae(isUpdatingAccountData.data.avator,`${id}/accounts`)
            if(url) uploadJson.avator=url
        }
        
        let res = await adminUpdateAccountData(props.token?.token,isUpdatingAccountData?._id,uploadJson)
        if(res.errno===0){
            setIsUpdatingAccountData(false)
            fetchMerchantAccounts()
        } else {
            alert(res.message||'更新失敗')
        }
        setIsloading(false)
    }

    const [isCreatingNewAccount,setIsCreatingNewAccount]=useState(false)
    const handleCreateNewAccount=()=>{
        setIsCreatingNewAccount({englishName:'',position:'',company:'',avatar:null})
    }
    const onDropCreateAccountAvator=(files)=>{
        if(!isCreatingNewAccount) return
        if(!files||files.length===0) return
        if(files.length>1) return alert('只能上傳一張圖片')
        let file = files[0]
        if(file.size>1024*1024*2) return alert('圖片大小不能超過2MB')
        setIsCreatingNewAccount({...isCreatingNewAccount,avatar:file})
    }
    const onDropUpdateAccountAvator=(files)=>{
        if(!isUpdatingAccountData) return
        if(!files||files.length===0) return
        if(files.length>1) return alert('只能上傳一張圖片')
        let file = files[0]
        if(file.size>1024*1024*2) return alert('圖片大小不能超過2MB')
        setIsUpdatingAccountData({...isUpdatingAccountData,data:{...isUpdatingAccountData.data,avator:file}})
    }
    async function handleConfirmCreateNewAccount(){
        if(!isCreatingNewAccount) return
        if(!isCreatingNewAccount?.email || isCreatingNewAccount?.email.trim()==='') return alert('請輸入電子郵件')
        if(validateEmail(isCreatingNewAccount?.email)===false) return alert('電子郵件格式錯誤')
        if(!isCreatingNewAccount?.password || isCreatingNewAccount?.password.trim()==='') return alert('請輸入密碼')
        if(isCreatingNewAccount?.password.length<5) return alert('密碼長度至少5個字元')
        if(!isCreatingNewAccount?.englishName || isCreatingNewAccount?.englishName.trim()==='') return alert('請輸入顯示名稱')
        let json={
            email:isCreatingNewAccount?.email,
            password:isCreatingNewAccount?.password,
            position:isCreatingNewAccount?.position||'',
            company:isCreatingNewAccount?.company||'',
            englishName:isCreatingNewAccount?.englishName||'',
            partnerId: id,
        }
        setIsloading(true)
        if(isCreatingNewAccount.avatar && isCreatingNewAccount.avatar instanceof File){
            let url = await onUploadOneImgae(isCreatingNewAccount.avatar,`${id}/accounts`)
            if(url) json.avator=url
        }
        let result = await adminAddCommunityAccount(props.token?.token,json)
        if(result.errno===0){
            setIsCreatingNewAccount(false)
            fetchMerchantAccounts()
        } else {
            alert(result.message||'新增失敗')
        }
        setIsloading(false)
    }

    const [isDeleteingAccount, setisDeleteingAccount] = useState(false)
    const handleConfirmDeleteAccount = async () => {
        setIsloading(true)
        const res = await adminDeleteAccount(props.token.token, isDeleteingAccount._id)
        setIsloading(false)
        if (res.errno) return alert('刪除失敗: ' + JSON.stringify(res.message))
        if (res.result) {
            alert('刪除成功')
            setisDeleteingAccount(false)
            fetchMerchantAccounts()
        }
    }

    return(
        <div className="h-full flex w-full h-full flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]">
            <div className="w-full flex flex-row items-start justify-start h-full">
                {/*left side: partner's account list*/}
                <div className="w-[300px] h-full px-[4px] gap-[16px]" style={{borderRight:'1px solid #ccc'}}>
                    <div className="w-full flex flex-row items-center justify-between mb-[16px]">
                        <div className="text-[18px] font-bold text-[#33222]">合作夥伴社群帳號</div>
                        <button onClick={handleCreateNewAccount} className="bg-[#0F737E] text-white px-[16px] py-[8px] hover:opacity-[.5] text-[12px]" style={{borderRadius:4}}>新增帳號</button>
                    </div>


                    {accounts?.map((item,index)=>
                        <div className="w-full flex flex-col items-start justify-start mb-[16px]" key={index} style={{borderBottom:'1px solid #ccc',paddingBottom:8}}>
                            <div  onClick={handleSelectAccount(item)} className={`flex flex-row gap-[8px] w-full p-[8px] cursor-pointer ${selectedAccount===item?._id?'bg-[#0F737E] text-white':'bg-white text-black'}`} style={{borderRadius:8}}>
                                <div className="flex w-[50px] h-[50px] rounded-[25px] overflow-hidden bg-white" style={{border:'.5px solid #ccc'}}>
                                    <img src={item?.data?.avator} className="w-full h-full" style={{objectFit:'cover'}}/>
                                </div>
                                <div className="flex flex-col flex-1">
                                    <div className="text-[16px] font-bold">{item?.data?.englishName||'未命名'}</div>
                                    <div className="text-[14px]">{item?.data?.position||''} | {item?.data?.company||''}</div>
                                </div>
                            </div>
                            <div className="flex flex-row gap-[8px] mt-[4px]">
                                <button onClick={()=>{setIsUpdatingAccountData(item)}} className={`bg-transparent text-[#0F737E] text-[12px] border border-[#0F737E] px-[8px] py-[4px] hover:opacity-[.5]`} style={{borderRadius:4}}>編輯資料</button>
                                <button onClick={()=>{setisDeleteingAccount(item)}} className={`bg-transparent text-[#FF0000] text-[12px] border border-[#FF0000] px-[8px] py-[4px] hover:opacity-[.5]`} style={{borderRadius:4}}>刪除帳號</button>
                            </div>
                        </div>
                    )}
                </div>

                {/*right side: posts list*/}
                <div className="flex-1 h-full pl-[16px] flex flex-col overflow-auto items-center">
                    <div className="w-full flex flex-row items-center justify-between mb-[16px]">
                        <div className="flex flex-row items-center px-[8px]" style={{gap:8}}>
                            <button onClick={handleNewPost} className="bg-[#0F737E] text-white px-[16px] py-[8px] hover:opacity-[.5] text-[12px]" style={{borderRadius:4}}>新增貼文</button>
                        </div>
                    </div>
                    {isloading
                        ?<div className="w-full h-full flex items-center justify-center">載入中...</div>
                        :data?.length===0
                        ?<div className="w-full h-full flex items-center justify-center">沒有貼文</div>
                        :<div className="w-full flex flex-col gap-[16px] max-w-[600px]">
                            {data?.map((item,index)=>
                            <div key={index} className="w-full flex flex-col items-center justify-start relative">
                                <div className="w-full">
                                    {/*delete button*/}
                                    <button onClick={()=>{setIsDeleting(item)}} className=" absolute top-[8px] right-[8px] w-[30px] h-[30px] rounded-[15px] bg-[#00000080] text-white flex items-center justify-center">X</button>
                                </div>
                                <div className="w-full bg-white rounded-[8px] overflow-hidden pb-[8px]" style={{boxShadow:'0 2px 4px rgba(0,0,0,0.1)'}}>
                                    <div className="w-full flex flex-row p-[16px] items-start justify-between" style={{gap:16}}>
                                        <div className="bg-white w-[48px] h-[48px] rounded-[24px]">
                                            <img src={item?.createdByUser?.[0]?.data?.avator} className="w-full h-full rounded-[24px]" style={{objectFit:'cover'}}/>
                                        </div>
                                        <div className="flex-col items-start flex-1 justify-between" height={48}>
                                            <div className="text-[#6E604C] font-bold" style={{fontSize:18}}>{item?.createdByUser?.[0]?.data?.englishName||item?.createdByUser?.[0]?.data?.firstname||''}</div>
                                            <div className="text-[#425457] font-[400]" style={{fontSize:16}}>{item?.createdByUser?.[0]?.data?.position||''} | {item?.createdByUser?.[0]?.data?.company||''}</div>
                                            <div className="text-[#425457] font-[400]" style={{fontSize:16}}>{new Date(item?.createDate).toLocaleString()}</div>
                                        </div>
                                    </div>

                                    {/*main content*/}
                                    {item?.data?.content&&
                                        <div className="w-full p-[16px]">
                                            <div className="font-[400] text-black" style={{fontSize:18,whiteSpace:'pre-wrap'}}>
                                                {item?.data?.content}
                                            </div>
                                        </div>
                                    }

                                    {
                                        item?.type==='photo'?
                                        <div className="w-full flex-col flex px-[24px]" style={{gap:16}}>
                                            {item?.data?.photos?.map((photo,index)=>
                                                <div key={index} className="flex-col" style={{objectFit:'contain',width:'100%'}}>
                                                    <img src={photo} className="w-full" style={{objectFit:'contain',borderRadius:8}}/>
                                                </div>
                                            )}
                                        </div>
                                        :<div/>
                                    }
                                </div>
                            </div>
                            )}
                        </div>
                    }
                    <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage}/>
                </div>
            </div>
            {isCreating!==false&&
                <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 bg-[#00000050] flex justify-center items-center p-[16px] z-[2]">
                    <div className="w-full max-w-[600px] h-full max-h-[80vh] bg-white rounded-[8px] flex flex-col">
                        <div className="w-full flex flex-row items-center justify-between p-[16px]" style={{borderBottom:'1px solid #ccc'}}>
                            <div className="text-[18px] font-bold text-[#33222]">新增貼文</div>
                            <button onClick={()=>{setIsCreating(false)}} className="text-[14px] text-[#33222] px-[8px] py-[4px] hover:opacity-[.5]" style={{borderRadius:4,border:'1px solid #ccc'}}>關閉</button>
                        </div>
                        <div className="w-full h-full flex flex-col p-[16px] overflow-auto" style={{gap:16}}>
                            <div className="flex flex-col w-full">
                                <div className="text-[14px] font-bold mb-[8px]">內容</div>
                                <textarea value={isCreating?.content||''} onChange={(e)=>{setIsCreating({...isCreating,content:e.target.value})}} className="w-full min-h-[100px] p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            </div>
                            <div className="flex flex-row w-full justify-start items-start" style={{gap:16,overflowX:'auto'}}>
                                {isCreating?.photos?.map((photo,index)=>
                                    <div key={index} className="w-[100px] h-[100px] rounded-[8px] overflow-hidden bg-white relative" style={{border:'1px solid #ccc'}}>
                                        <div>{photo instanceof File
                                            ?<img src={URL.createObjectURL(photo)} className="w-full h-full" style={{objectFit:'cover'}}/>
                                            :<img src={photo} className="w-full h-full" style={{objectFit:'cover'}}/>
                                        }</div>
                                        <button onClick={()=>{
                                            let currentFiles = isCreating?.photos||[]
                                            currentFiles.splice(index,1)
                                            setIsCreating({...isCreating,photos:[...currentFiles]})
                                        }} className=" absolute top-[4px] right-[4px] w-[24px] h-[24px] rounded-[12px] bg-[#00000080] text-white flex items-center justify-center">X</button>
                                    </div>
                                )}
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="text-[14px] font-bold mb-[8px]">圖片</div>
                                <div style={{border:'1px dashed #ccc',borderRadius:4,padding:8}}>
                                 <FileDropzone onDropFile={onDropFile} data={isCreating}/>
                                </div>
                            </div>

                            <button onClick={handleConfirmCreateNewPost} className="bg-[#0F737E] text-white px-[16px] py-[8px] hover:opacity-[.5] self-start" style={{borderRadius:4}}>發布貼文</button>
                        </div>
                    </div>
                </div>
            }
            {isDeleting!==false&&
                <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 bg-[#00000050] flex justify-center items-center p-[16px] z-[2]">
                    <div className="w-full max-w-[400px] bg-white rounded-[8px] flex flex-col">
                        <div className="w-full flex flex-row items-center justify-between p-[16px]" style={{borderBottom:'1px solid #ccc'}}>
                            <div className="text-[18px] font-bold text-[#33222]">刪除貼文</div>
                        </div>
                        <div className="w-full p-[16px] flex flex-col" style={{gap:16}}>
                            <div className="text-[16px]">確定要刪除這篇貼文嗎？</div>
                            <div className="text-[14px] text-[#666]">貼文內容：{isDeleting?.data?.content?.slice(0,20)}{isDeleting?.data?.content?.length>20?'...':''}</div>
                            <div className="text-[14px] text-[#666]">刪除後將無法復原</div>

                            <div className="flex flex-row" style={{gap:16}}>
                                <button onClick={()=>{setIsDeleting(false)}} className="bg-[#ccc] text-black px-[16px] py-[8px] hover:opacity-[.5]" style={{borderRadius:4}}>取消</button>
                                <button onClick={handleConfirmDeletePost} className="bg-[#F44336] text-white px-[16px] py-[8px] hover:opacity-[.5]" style={{borderRadius:4}}>刪除</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isUpdatingAccountData!==false&&
                <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 bg-[#00000050] flex justify-center items-center p-[16px] z-[2]">
                    <div className="w-full max-w-[400px] bg-white rounded-[8px] flex flex-col">
                        <div className="w-full flex flex-row items-center justify-between p-[16px]" style={{borderBottom:'1px solid #ccc'}}>
                            <div className="text-[18px] font-bold text-[#33222]">編輯合作夥伴帳號資料</div>
                            <button onClick={()=>{setIsUpdatingAccountData(false)}} className="text-[14px] text-[#33222] px-[8px] py-[4px] hover:opacity-[.5]" style={{borderRadius:4,border:'1px solid #ccc'}}>關閉</button>
                        </div>
                        <div className="w-full p-[16px] flex flex-col" style={{gap:16}}>
                            <div>顯示名稱</div>
                            <input value={isUpdatingAccountData?.data?.englishName||isUpdatingAccountData?.data?.firstname||''} onChange={(e)=>{setIsUpdatingAccountData({...isUpdatingAccountData,data:{...isUpdatingAccountData.data,englishName:e.target.value}})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>職位</div>
                            <input value={isUpdatingAccountData?.data?.position||''} onChange={(e)=>{setIsUpdatingAccountData({...isUpdatingAccountData,data:{...isUpdatingAccountData.data,position:e.target.value}})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>公司</div>
                            <input value={isUpdatingAccountData?.data?.company||''} onChange={(e)=>{setIsUpdatingAccountData({...isUpdatingAccountData,data:{...isUpdatingAccountData.data,company:e.target.value}})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>

                            <div>頭像 (建議大小100px x 100px，檔案小於2MB)</div>
                            {isUpdatingAccountData?.data?.avator?
                            <div className="w-[100px] h-[100px] rounded-[8px] overflow-hidden bg-white relative" style={{border:'1px solid #ccc'}}>
                                <div>{isUpdatingAccountData?.data?.avator instanceof File
                                    ?<img src={URL.createObjectURL(isUpdatingAccountData?.data?.avator)} className="w-full h-full" style={{objectFit:'cover'}}/>
                                    :<img src={isUpdatingAccountData?.data?.avator} className="w-full h-full" style={{objectFit:'cover'}}/>
                                }</div>
                                <button onClick={()=>{
                                    setIsUpdatingAccountData({...isUpdatingAccountData,data:{...isUpdatingAccountData.data,avator:null}})
                                }} className=" absolute top-[4px] right-[4px] w-[24px] h-[24px] rounded-[12px] bg-[#00000080] text-white flex items-center justify-center">X</button>
                            </div>
                            :<div style={{border:'1px dashed #ccc',borderRadius:4,padding:8}}>
                                <FileDropzone onDropFile={onDropUpdateAccountAvator} data={isUpdatingAccountData}/>
                            </div>}
                            <button onClick={handleConfirmUpdateAccountData} className="bg-[#0F737E] text-white px-[16px] py-[8px] hover:opacity-[.5] self-start" style={{borderRadius:4}}>儲存資料</button>
                        </div>
                    </div>
                </div>
            }
            {isCreatingNewAccount!==false&&
                <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 bg-[#00000050] flex justify-center items-center p-[16px] z-[2]">
                    <div className="w-full max-w-[500px] bg-white rounded-[8px] flex flex-col">
                        <div className="w-full flex flex-row items-center justify-between p-[16px]" style={{borderBottom:'1px solid #ccc'}}>
                            <div className="text-[18px] font-bold text-[#33222]">新增合作夥伴帳號</div>
                            <button onClick={()=>{setIsCreatingNewAccount(false)}} className="text-[14px] text-[#33222] px-[8px] py-[4px] hover:opacity-[.5]" style={{borderRadius:4,border:'1px solid #ccc'}}>關閉</button>
                        </div>
                        <div className="w-full p-[16px] flex flex-col" style={{gap:16}}>
                            <div>電子郵件 (之後無法編輯)</div>
                            <input value={isCreatingNewAccount?.email||''} onChange={(e)=>{setIsCreatingNewAccount({...isCreatingNewAccount,email:e.target.value})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>密碼</div>
                            <input type="password" value={isCreatingNewAccount?.password||''} onChange={(e)=>{setIsCreatingNewAccount({...isCreatingNewAccount,password:e.target.value})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>顯示名稱</div>
                            <input value={isCreatingNewAccount?.englishName||''} onChange={(e)=>{setIsCreatingNewAccount({...isCreatingNewAccount,englishName:e.target.value})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>職位</div>
                            <input value={isCreatingNewAccount?.position||''} onChange={(e)=>{setIsCreatingNewAccount({...isCreatingNewAccount,position:e.target.value})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            <div>公司</div>
                            <input value={isCreatingNewAccount?.company||''} onChange={(e)=>{setIsCreatingNewAccount({...isCreatingNewAccount,company:e.target.value})}} className="w-full p-[8px]" style={{border:'1px solid #ccc',borderRadius:4}}/>
                            
                            <div>頭像 (建議大小100px x 100px，檔案小於2MB)</div>
                            {isCreatingNewAccount.avatar?
                            <div className="w-[100px] h-[100px] rounded-[8px] overflow-hidden bg-white relative" style={{border:'1px solid #ccc'}}>
                                <div><img src={URL.createObjectURL(isCreatingNewAccount.avatar)} className="w-full h-full" style={{objectFit:'cover'}}/></div>
                                <button onClick={()=>{
                                    setIsCreatingNewAccount({...isCreatingNewAccount,avatar:null})
                                }} className=" absolute top-[4px] right-[4px] w-[24px] h-[24px] rounded-[12px] bg-[#00000080] text-white flex items-center justify-center">X</button>
                            </div>
                            :<div style={{border:'1px dashed #ccc',borderRadius:4,padding:8}}>
                                <FileDropzone onDropFile={onDropCreateAccountAvator} data={isCreatingNewAccount}/>
                            </div>}

                            <button onClick={handleConfirmCreateNewAccount} className="bg-[#0F737E] text-white px-[16px] py-[8px] hover:opacity-[.5] self-start" style={{borderRadius:4}}>建立帳號</button>
                        </div>
                    </div>
                </div>
            }
            {isDeleteingAccount!==false&&
                <div className="w-full h-full fixed top-0 left-0 right-0 bottom-0 bg-[#00000050] flex justify-center items-center p-[16px] z-[2]">
                    <div className="w-full max-w-[400px] bg-white rounded-[8px] flex flex-col">
                        <div className="w-full flex flex-row items-center justify-between p-[16px]" style={{borderBottom:'1px solid #ccc'}}>
                            <div className="text-[18px] font-bold text-[#33222]">刪除合作夥伴帳號</div>
                        </div>
                        <div className="w-full p-[16px] flex flex-col" style={{gap:16}}>
                            <div className="text-[16px]">確定要刪除這個合作夥伴帳號嗎？</div>
                            <div className="text-[14px] text-[#666]">帳號名稱：{isDeleteingAccount?.data?.englishName||isDeleteingAccount?.data?.firstname||''}</div>
                            <div className="text-[14px] text-[#666]">刪除後將無法復原</div>

                            <div className="flex flex-row" style={{gap:16}}>
                                <button onClick={()=>{setisDeleteingAccount(false)}} className="bg-[#ccc] text-black px-[16px] py-[8px] hover:opacity-[.5]" style={{borderRadius:4}}>取消</button>
                                <button onClick={handleConfirmDeleteAccount} className="bg-[#F44336] text-white px-[16px] py-[8px] hover:opacity-[.5]" style={{borderRadius:4}}>刪除</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)


